/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ start: NonNullable<unknown>, end: NonNullable<unknown> }} Gateway_Sub_Plan_Card_Period_FormatInputs */



/**
* | output |
* | --- |
* | "{start} → {end}" |
*
* @param {Gateway_Sub_Plan_Card_Period_FormatInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const gateway_sub_plan_card_period_format = /** @type {((inputs: Gateway_Sub_Plan_Card_Period_FormatInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gateway_Sub_Plan_Card_Period_FormatInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.start} → ${i?.end}`)
	return /** @type {LocalizedString} */ (`${i?.start} → ${i?.end}`)
});